import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';

import {AuthenticationService} from '../../../../core/services/AuthServices/auth.service';
import {indexNoValidator, phoneNumberValidator} from "../../../../Modules/Shared/UtilityClass/CustomValidators";
import {Subscription} from "rxjs";
import {Beneficiary} from "../../../../Modules/Shared/Models/Beneficiary";
import {HttpErrorResponse} from "@angular/common/http";
import {CustomSwal} from "../../../../Modules/Shared/Services/CustomSwal";
import {AuthServerResponseObject} from "../../Models/AuthServerResponseObject";
import {RegisterBenefReq} from "../../Models/Requests/RegisterBenefReq";

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit, OnDestroy {

  signupForm: UntypedFormGroup;
  submitted = false;
  error = '';
  successmsg = false;

  // set the current year
  year: number = new Date().getFullYear();
  showBenefForm: boolean;
  showRefundForm: boolean;
  hasIndexNo: number;
  indexDetails: Beneficiary;
  refundIndexDetails: Beneficiary;
  showUseAdvanceSeach: boolean;
  registeredBenef: Beneficiary;
  // convenience getter for easy access to form fields
  loadingSubmit: boolean;
  private subscriptions: Subscription[] = [];

  get f() {
    return this.signupForm?.controls;
  }

  // tslint:disable-next-line: max-line-length
  showEmailPassword: boolean;

  constructor(private formBuilder: UntypedFormBuilder,
              private route: ActivatedRoute,
              private router: Router,
              private authenticationService: AuthenticationService
  ) {
  }

  ngOnInit() {
    this.signupForm = this.formBuilder.group({
      regType: [ Validators.required],
      benefIndexNo: ['', [Validators.required, indexNoValidator()]],
      refundIndexNo: ['', [Validators.required, indexNoValidator()]],
      hasf4Index: ['', Validators.required],
      firstName: ['', Validators.required],
      middleName: ['',],
      lastName: ['', Validators.required],
      sex: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, phoneNumberValidator()]],
      password: ['', Validators.required],
    });
  }


  /**
   * On submit form
   */
  onSubmit(value: any) {
    this.registeredBenef = null;
    // make request object
    const req: RegisterBenefReq = new RegisterBenefReq();
    if(value.regType == 'refundApplication') {
      req.account_type = 2
      req.benef_index_no = value.refundIndexNo?.toUpperCase();
    }
    else {
      req.account_type = 1;
      req.benef_index_no = value.benefIndexNo?.toUpperCase();
    }
    req.has_index_no = value.hasf4Index == 'true';
    req.first_name = value.firstName;
    if(req.middle_name != '')
    {
      req.middle_name = value.middleName;
    }
    req.last_name = value.lastName;
    req.sex = value.sex;
    req.password = value.password;
    req.email = value.email;
    // add regex to remove empty spaces in phone_no_reg
    req.phone_number = value.phone?.replace(/\s/g, '');

    this.loadingSubmit = true;
    this.subscriptions.push(this.authenticationService.registerBenefRefundApplicant(req).subscribe({
      next: (response: AuthServerResponseObject) => {
        this.registeredBenef = response?.body;
        CustomSwal.toastSuccess(`You Have Been Register Please Login With The UserName ${this.registeredBenef?.index_no}`)
        this.loadingSubmit = false;
      },
      error: (error: HttpErrorResponse) => {
        CustomSwal.toastFailed(error.error.detail);
        this.loadingSubmit = false;
      }
    }));
  }

  changeRegistrationType($event: any) {
    this.registeredBenef = null;
    this.showEmailPassword = false;
    this.refundIndexDetails = null;
    this.indexDetails = null;
    this.showUseAdvanceSeach = false;
    this.resetEmailPassFields();
    if ($event.target.value == 'beneficiary') {
      this.showBenefForm = true;
      this.showRefundForm = false;
      // remove required validators for all refund form params
      this.removeRequiredValidators('refundIndexNo');
      this.removeRequiredValidators('hasf4Index');
      this.removeRequiredValidators('firstName');
      this.removeRequiredValidators('lastName');
      this.removeRequiredValidators('sex');

      // add the beneficiary must provide an index-no
      this.addRequiredValidators('benefIndexNo');

    } else if ($event.target.value == 'refundApplication') {
      this.showBenefForm = false;
      this.showRefundForm = true;
      // remove required validators for all benef form params
      this.removeRequiredValidators('benefIndexNo');
      // push the has index-no control
      this.addRequiredValidators('hasf4Index');
      this.hasIndexNo = null;
    } else {
      this.showBenefForm = false;
      this.showRefundForm = false;
    }

  }

  changeHasIndexNo($event) {
    this.registeredBenef = null;
    this.refundIndexDetails = null;
    this.indexDetails = null;
    this.showUseAdvanceSeach = false;
    if ($event.target.value == 'true') {
      this.hasIndexNo = 1;
      this.showEmailPassword = false;
      this.resetEmailPassFields();
      // remove controls-for names
      this.removeRequiredValidators('firstName');
      this.removeRequiredValidators('lastName');
      this.removeRequiredValidators('sex');

      // add control for refund index-no
      this.addRequiredValidators('refundIndexNo')
    } else {
      this.hasIndexNo = 0;
      this.showEmailPassword = true;
      // add controls for names
      this.addRequiredValidators('firstName');
      this.addRequiredValidators('lastName');
      this.addRequiredValidators('sex');

      // remove control for refund index-no
      this.removeRequiredValidators('refundIndexNo');
    }
  }


  removeRequiredValidators(control_name: string) {
    this.signupForm?.controls[control_name].removeValidators([Validators.required]);
    this.signupForm?.controls[control_name].reset();
    this.signupForm?.controls[control_name].updateValueAndValidity();
    this.signupForm?.controls[control_name].setValue(null);
  }

  addRequiredValidators(control_name: string) {
    this.signupForm?.controls[control_name].addValidators([Validators.required]);
    this.signupForm?.controls[control_name].updateValueAndValidity();
  }

  resetEmailPassFields() {
    this.signupForm?.controls['password'].reset();
    this.signupForm?.controls['email'].reset();
    this.signupForm?.controls['phone'].reset();
  }

  onChangeBenefIndexNo() {
    this.registeredBenef = null;
    this.showUseAdvanceSeach = false;
    this.indexDetails = null;
    this.showEmailPassword = false;
    this.resetEmailPassFields();
    // check if the index_no is valid
    console.log('here')
    if (this.signupForm?.controls['benefIndexNo'].valid) {
      console.log('form-valid')
      this.subscriptions.push(this.authenticationService.getIndexNoDetails(this.signupForm?.controls['benefIndexNo'].value, 1).subscribe(
        {
          next: (response: AuthServerResponseObject) => {
            this.indexDetails = response?.body;
            this.showEmailPassword = true;
          },
          error: (errorResponse: HttpErrorResponse) => {
            this.showUseAdvanceSeach = true;
            CustomSwal.toastFailed(errorResponse?.error?.detail);
          }
        }
      ))
    }
  }

  onChangeRefundIndexNo() {
    this.indexDetails = null;
    this.refundIndexDetails = null;
    this.showEmailPassword = false;
    this.registeredBenef = null;
    this.resetEmailPassFields();
    // check if valid
    if (this.signupForm?.controls['refundIndexNo'].valid) {
      this.subscriptions.push(this.authenticationService.getIndexNoDetails(this.signupForm?.controls['refundIndexNo'].value, 2).subscribe(
        {
          next: (response: AuthServerResponseObject) => {
            this.refundIndexDetails = response?.body;
            this.showEmailPassword = true;
          },
          error: (errorResponse: HttpErrorResponse) => {
            CustomSwal.toastFailed(errorResponse?.error?.detail);
          }
        }
      ));
    }

  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
